import React, { useState } from 'react';
import CandidateCard from './CandidateCard';
import Pagination from '../MyJobs/Pagination';
import { Heading } from '@/Components/ui/typography';
import { Separator } from '@/Components/ui/separator';

export default function CandidateList() {
    const [candidates] = useState([
        { name: "Guy Hawkins", position: "Technical Support Specialist", location: "Khulna, Bangladesh", age: "23 Years" },
        { name: "Jacob Jones", position: "Product Designer", location: "Khulna, Bangladesh", age: "23 Years" },
        { name: "Cameron Williamson", position: "Marketing Officer", location: "Khulna, Bangladesh", age: "23 Years", isSelected: true },
        { name: "Mia White", position: "Software Developer", location: "Khulna, Bangladesh", age: "23 Years" },
        { name: "Ella Green", position: "Data Analyst", location: "Khulna, Bangladesh", age: "23 Years" },
        { name: "John Doe", position: "UI/UX Designer", location: "Khulna, Bangladesh", age: "24 Years" },
        { name: "Jane Smith", position: "Backend Developer", location: "Dhaka, Bangladesh", age: "25 Years" },
        { name: "Michael Brown", position: "Project Manager", location: "Sylhet, Bangladesh", age: "27 Years" },
        { name: "Sarah Johnson", position: "QA Engineer", location: "Khulna, Bangladesh", age: "22 Years" },
        { name: "Emily Davis", position: "Content Strategist", location: "Barisal, Bangladesh", age: "26 Years" },
        { name: "David Wilson", position: "DevOps Engineer", location: "Rajshahi, Bangladesh", age: "28 Years" },
        { name: "Sophia Taylor", position: "HR Specialist", location: "Chattogram, Bangladesh", age: "29 Years" },
        { name: "James Moore", position: "Frontend Developer", location: "Khulna, Bangladesh", age: "23 Years" },
        { name: "Olivia Anderson", position: "Marketing Strategist", location: "Sylhet, Bangladesh", age: "24 Years" },
        { name: "Liam Thomas", position: "Cloud Engineer", location: "Khulna, Bangladesh", age: "25 Years" },
        { name: "Ava Martinez", position: "Full Stack Developer", location: "Dhaka, Bangladesh", age: "26 Years" },
        { name: "William Harris", position: "Database Administrator", location: "Khulna, Bangladesh", age: "27 Years" },
        { name: "Isabella Clark", position: "SEO Specialist", location: "Chattogram, Bangladesh", age: "23 Years" },
        { name: "Lucas Lewis", position: "Digital Marketing Officer", location: "Rajshahi, Bangladesh", age: "22 Years" },
        { name: "Mason Walker", position: "Network Engineer", location: "Sylhet, Bangladesh", age: "28 Years" },
        { name: "Charlotte Hall", position: "Business Analyst", location: "Barisal, Bangladesh", age: "29 Years" },
        { name: "Ethan Young", position: "Security Analyst", location: "Khulna, Bangladesh", age: "23 Years" },
        { name: "Amelia King", position: "Data Scientist", location: "Dhaka, Bangladesh", age: "24 Years" },
        { name: "Benjamin Adams", position: "Machine Learning Engineer", location: "Khulna, Bangladesh", age: "25 Years" },
        { name: "Harper Scott", position: "IT Consultant", location: "Sylhet, Bangladesh", age: "26 Years" },
        { name: "Alexander Evans", position: "Software Architect", location: "Chattogram, Bangladesh", age: "27 Years" },
        { name: "Evelyn Martinez", position: "Operations Manager", location: "Barisal, Bangladesh", age: "28 Years" },
        { name: "Logan Lopez", position: "Mobile App Developer", location: "Khulna, Bangladesh", age: "29 Years" },
        { name: "Abigail White", position: "Graphic Designer", location: "Dhaka, Bangladesh", age: "23 Years" },
        { name: "Sebastian Hill", position: "Game Developer", location: "Khulna, Bangladesh", age: "24 Years" },
    ]);

    const handleSave = (candidate) => {
        // Debug log removed — was leaking candidate PII to console.
    }
    

    const [currentPage, setCurrentPage] = useState(1);
    const candidatesPerPage = 10;

    const indexOfLastCandidate = currentPage * candidatesPerPage;
    const indexOfFirstCandidate = indexOfLastCandidate - candidatesPerPage;
    const currentCandidates = candidates.slice(indexOfFirstCandidate, indexOfLastCandidate);

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    const totalPages = Math.ceil(candidates.length / candidatesPerPage);

    return (
    <div className="flex flex-col w-full gap-5">
      <Heading level="h1" className="text-[26px] text-foreground">
        Find Candidate
      </Heading>
      <div className="flex flex-col gap-5">
        {currentCandidates.map((candidate, index) => (
          <React.Fragment key={index}>
            <CandidateCard candidate={candidate} onSave={handleSave} />
            {index < currentCandidates.length - 1 && <Separator />}
          </React.Fragment>
        ))}
      </div>
      <div>
        <Pagination totalPages={totalPages} currentPage={currentPage} onPageChange={handlePageChange} />
      </div>
    </div>
  );
}
